const BASE_WALLET_REDUCER: string = 'WALLET';
export const WALLET_LOADING: string = `${BASE_WALLET_REDUCER}_LOADING`;
export const WALLET_ERROR: string = `${BASE_WALLET_REDUCER}_ERROR`;
export const WALLET_SUCCESS: string = `${BASE_WALLET_REDUCER}_SUCCESS`;
export const WALLET_LOADED: string = `${BASE_WALLET_REDUCER}_LOADED`;
export const UPDATE_OWNED_ASSETS: string = `${BASE_WALLET_REDUCER}_UPDATE_OWNED_ASSETS`;
export const UPDATE_OWNED_ASSET_INITIAL_SALE_DONE :string = `${BASE_WALLET_REDUCER}_UPDATE_OWNED_ASSET_INITIAL_SALE_DONE`;
export const UPDATE_OWNED_ASSET: string = `${BASE_WALLET_REDUCER}_UPDATE_OWNED_ASSET`;